import styled from 'styled-components';
import { rem } from '../../utils/Polished';
export default styled.div `
  z-index: ${(p) => p.theme.zIndex.topLayer};
  border-radius: ${(p) => p.theme.SizeBorderRadiusTooltipBase};

  font-family: ${(p) => p.theme.FontFamilyBase};
  font-size: ${(p) => p.theme.SizeFontTooltipBase};
  line-height: ${(p) => p.theme.SizeLineHeightTooltipBase};
  overflow-wrap: break-word;
  white-space: normal;
  transition: opacity 0.1s linear;

  ._ndsTooltip__backdrop {
    z-index: ${(p) => p.theme.zIndex.topLayer - 1};
  }

  ._ndsTooltip__content {
    z-index: ${(p) => p.theme.zIndex.default + 2};
    box-sizing: border-box;
    border-radius: ${(p) => p.theme.SizeBorderRadiusTooltipBase};
    max-width: ${(p) => p.theme.SizeWidthTooltipBase};
  }

  ._ndsTooltip__arrow {
    z-index: ${(p) => p.theme.zIndex.default - 1};
    position: absolute;
    transform-origin: center;
    transform: rotate(45deg);
  }

  &[data-placement*='top'] ._ndsTooltip__arrow {
    bottom: 0;
    margin-bottom: ${rem('-6px')};
  }

  &[data-placement*='right'] ._ndsTooltip__arrow {
    left: 0;
    margin-left: ${rem('-6px')};
  }

  &[data-placement*='bottom'] ._ndsTooltip__arrow {
    top: 0;
    margin-top: ${rem('-6px')};
  }

  &[data-placement*='left'] ._ndsTooltip__arrow {
    right: 0;
    margin-right: ${rem('-6px')};
  }
`;
//# sourceMappingURL=TooltipBaseSC.js.map